import { buildWarrantyMobilesArrayFromFormValues } from "../../../../functions/warrantyMobilesFormValues";

export const handleSubmitForm = (values, dataBarcode, mutateUpload) => {
  const uploadData = {
    invImage: values.invImage ? values.invImage[0] : null,
    packageImage: values.packageImage ? values.packageImage[0] : null,
    telephone: values.telephone,
    fullName: values.fullName,
    mobiles: buildWarrantyMobilesArrayFromFormValues(values),
    productId: dataBarcode.item.productId,
    channelBuyId: values.channelBuyId,
  };

  mutateUpload(uploadData);
};
